<template>
    <el-card class="box-card" v-loading="dataLoading">
        <div slot="header" class="clearfix">
            <span>
                <span class="el-icon-data-line"></span> 众筹管理
            </span>
            <router-link v-if="$utils.have('/sales/raise/list') && intervalData" class="fr color-theme" :to="`/report/sales/crowdfunding?timeStartStr=${intervalData.startTime} 00:00:00&timeEndStr=${intervalData.endTime} 23:59:59`">
                查看详情<span class="el-icon-right"></span>
            </router-link>
        </div>
        <div v-if="data" class="content">
            <el-row :gutter="20" class="auditTotalNum">
                <el-col :sm="6">
                    <el-card shadow="never">
                        <router-link to="/raise/audit/list">
                            <div class="title">上线审核</div>
                            <div class="num clearfix">
                                <b>{{data.raiseAuditTotalNum || 0}}</b> 当前待处理
                                <span class="el-icon-right fr"></span>
                            </div>
                        </router-link>
                    </el-card>
                </el-col>
                <el-col :sm="6">
                    <el-card shadow="never">
                        <router-link to="/finance/raise/settlement/list?downPaymentType=3">
                            <div class="title">首款结款</div>
                            <div class="num clearfix">
                                <b>{{data.downPaymentTotalNum || 0}}</b> 当前待处理
                                <span class="el-icon-right fr"></span>
                            </div>
                        </router-link>
                    </el-card>
                </el-col>
                <el-col :sm="6">
                    <el-card shadow="never">
                        <router-link to="/finance/raise/settlement/list?retainageType=3">
                            <div class="title">尾款结款</div>
                            <div class="num clearfix">
                                <b>{{data.receivablesTotalNum || 0}}</b> 当前待处理
                                <span class="el-icon-right fr"></span>
                            </div>
                        </router-link>
                    </el-card>
                </el-col>
                <el-col :sm="6">
                    <el-card shadow="never">
                        <router-link to="/raise/project/list">
                            <div class="title">众筹上线</div>
                            <div class="num clearfix">
                                <b>{{data.raiseOnlineNum || 0}}</b>
                                <span class="el-icon-right fr"></span>
                            </div>
                        </router-link>
                    </el-card>
                </el-col>
            </el-row>

            <el-tabs v-model="activeName"  @tab-click="clickTab" class="MT10">
                <el-tab-pane label="金额" name="1"></el-tab-pane>
                <el-tab-pane label="订单" name="2"></el-tab-pane>
                <el-tab-pane label="项目" name="3"></el-tab-pane>
            </el-tabs>
            
            <div class="data-box">
                <div class="total">
                    {{activeName == 1 ? '金额:' : activeName == 2 ? '订单:' : '项目:' }} 
                    <b>{{data && data.totalSum}} </b> 
                    <router-link v-if="$utils.have('/sales/raise/list') && intervalData" class="color-theme" :to="`/report/sales/crowdfunding?timeStartStr=${intervalData.startTime} 00:00:00&timeEndStr=${intervalData.endTime} 23:59:59`">(详情)</router-link>
                </div>
                <div id="raiseDataChart" ref="raiseDataChart"></div>
            </div>
        </div>
    </el-card>
</template>

<script>
import { Chart } from '@antv/g2';


export default {
    props:{
        intervalData:{
            type: Object,
            default: () => null
        },
        daterange: {
            type: Array,
            default: () => []
        }
    },
    data(){
        return{
            dataLoading: false,
            data: null,
            activeName: "1",
            chart: null,
        }
    },
    mounted(){
        this.getData();
    },
    watch:{
        intervalData(v1,v2){
            if(v1 && v1 != v2){
                this.getData();
            }
        }
    },
    methods:{
        getData(){
            this.dataLoading = true;
            this.$request({
                url: this.activeName == 1 ? "/dashboard/raisedata/orderamount" : this.activeName == 2 ? "/dashboard/raisedata/ordernum" : "/dashboard/raisedata",
                method: "POST",
                data: {
                    timeInterval: this.intervalData.timeInterval || "",
                    start: this.daterange.length > 0 ? this.daterange[0]: "",
                    end: this.daterange.length > 1 ? this.daterange[1]: "",
                }
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1 && result) {
                        this.data = result;

                        this.$nextTick(() => {
                            this.drawChart();
                        })
                        
                    } else {
                        this.$message.error(msg || "请求失败");
                    }
                })
                .catch(() => {
                    this.$message.error("请求错误");
                })
                .finally(() => {
                    this.dataLoading = false;
                });
        },
        clickTab(){
            this.getData();
        },
        drawChart(){
            if( this.chart ) this.chart.destroy();
            let _data = [];
            const _dataArry = [...this.data.totalNumChart.lineSeriesData];

            _dataArry.map( item => {
                _data.push({
                    name: item.name,
                    value: parseFloat(item.value)
                })
            })
            
            this.chart = new Chart({
                container: 'raiseDataChart',
                autoFit: true,
                height: 400,
            });
            this.chart.data(_data);

            if( _dataArry.length > 7 ){
                this.chart.option('slider', {
                    start: (_dataArry.length - 7) / _dataArry.length,
                    end: 1,
                });
            }

            this.chart.tooltip({
                showTitle: false,
                showMarkers: false,
                showCrosshairs: true,
            });
            
            this.chart
                .line()
                .position('name*value')
                .shape('smooth')
                .tooltip('name*value', (name, value) => {
                    value = this.activeName == 1 ? parseFloat(value).toFixed(2) : value;
                    return {
                        name: name,
                        value: value,
                    };
                });

            this.chart.render();
        }
    }
}
</script>

<style lang="scss" scoped>
.total{
    margin:10px 0 25px 0;
    b{
        font-size: 18px;
        font-weight: 700;
    }
}
.auditTotalNum{
    .num{
        margin-top: 10px;
        color: $--color-info;
        b{
            font-weight: 700;
            font-size: 16px;
            color: $--color-theme;
        }
    }
}
</style>